/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
import { api } from '@seaoil/component-lib';

import AsyncAutoComplete from './AsyncAutoComplete';

const { mySEAOIL } = api;

function CompanyField(props) {
  const {
    // attributes
    disabled,

    // methods
    onInputSelect,
  } = props;
  const [companies, setCompanies] = useState([]);
  const [loading, isLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const retryLimit = 5;
  let retryCount = 0;

  const loadCompanies = async () => {
    isLoading(() => true);
    try {
      const comps = await mySEAOIL.datawarehouse.getExpenseAcctEntry({
        attribute: 'company',
      }).send();
      setCompanies(comps);
    } catch (e) {
      if (retryCount > retryLimit) {
        notification.error({ message: 'Unable to load the company list after multiple retries. Kindly contact supportdesk@seaoil.com.ph' });
      } else {
        notification.error({ message: 'Unable to load the company list. Retrying after 2 seconds...' });
        setTimeout(loadCompanies, 2000);
        retryCount += 1;
      }
    } finally {
      isLoading(() => false);
    }
  };

  useEffect(() => {
    loadCompanies();
  }, []);

  useEffect(() => {
    if (!Array.isArray(companies)) {
      return;
    }
    setOptions(companies.map(({
      company_name,
    }) => ({
      value: company_name,
      label: company_name,
    })));
  }, [companies]);

  return (
    <AsyncAutoComplete
      placeholder="Company"
      loading={loading}
      disabled={disabled}
      options={options}
      onInputSelect={(company_name) => {
        if (companies) {
          onInputSelect(companies.find((company) => company.company_name === company_name));
        }
      }}
    />
  );
}

export default CompanyField;
